import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { ConfirmPickUp, GetAllProductShelf, ReadAllProcurementDeviceAssignment, ReadAllRequest, ReadAllRTSDeviceAssignment } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import PrintPickUp from './PrintPickUp'
import { configuration } from '../Utils/config'
import UpdateQty from '../Components/UpdateQty'
import UpdatePickUpQty from '../Components/UpdatePickUpQty'

export default function DeviceAssignmentRTS() {
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModelState, setModelState] = useState(false);
    const [PrintMode, setPrintMode] = useState(false);

    const [SearchText, setSearchText] = useState("");
    const [SingleData, setSingleData] = useState(false);

    const [Data, setData] = useState([]);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const [PreLoader, setPreLoader] = useState(true);

    const [OpenModal, setOpenModal] = useState(false);


    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [TransferId, setTransferId] = useState("");




    const GetAllRequest = async () => {
        let result = await ReadAllRTSDeviceAssignment()

        console.log("result request", result);

        if (result.status === true) {
            setData(result.queryresult.scndetails)
            setTotalData(result.queryresult.totalscndetails)
            setPreLoader(false)
        }
    }






    useEffect(() => {
        GetAllRequest()
    }, [isOpen, ModelState, OpenModal]);
    return (

        <MainLayout>

{
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Pick up" description='EKO IMS - Pick up' />
            <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                <Text textTransform="capitalize">Total Product Request - {TotalData}</Text>

            </Flex>


            <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Return By, Returnee Department, ProductName"} />
            <Box height="70vh" minH={"70vh"} overflow="scroll" w="100%" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>

                <TableContainer mt="32px" overflowX="auto" color="#fff">

                    <Table variant='simple' size='sm' >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Device Serial No</Th>
                                <Th color="#fff">Name</Th>
                                <Th color="#fff">Return by</Th>
                                <Th color="#fff">Batch Id</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Qty Certified</Th>
                                <Th color="#fff">Reference</Th>
                                <Th color="#fff">for device_assignment</Th>



                            </Tr>
                        </Thead>


                        <Tbody>
                            {
                                SearchText === "" ? (
                                    currentData?.map((item, i) => (
                                        <TableRow
                                            type={"device assignment RTS"}
                                            key={i}
                                            sn={i + 1}
                                            serialNo={item.deviceserialnumber}
                                            ticketNo={item.batchid}
                                            productName={item.shelfid.productname}
                                            qty={item.qtycertified}
                                            returnby={item.returnby}
                                            reference={item.reference}
                                            dept={item.batchid}
                                            store={item.store}
                                            isDeviceAssignment={item.fordeviceassignment}
                                            dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}

                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.returnby?.includes(SearchText)   || item.shelfid.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.returneedepartment?.includes(SearchText)).length > 0 ? (

                                        Data?.filter(item => item.returnby?.includes(SearchText) || item.staffid?.includes(SearchText) || item.returneedepartment?.includes(SearchText)).

                                            map((item, i) => (
                                                <TableRow
                                            type={"device assignment RTS"}
                                            key={i}
                                            sn={i + 1}
                                            serialNo={item.deviceserialnumber}
                                            productName={item.shelfid.productname}
                                            qty={item.qtycertified}
                                            returnby={item.returnby}
                                            reference={item.reference}
                                            dept={item.returneedepartment}
                                            isDeviceAssignment={item.fordeviceassignment}
                                            dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}

                                        />
                                            ))
                                    ) : (
                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                    )

                                )


                            }
                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />
                <UpdatePickUpQty SingleData={SingleData} state="request" isOpen={OpenModal} onClose={() => setOpenModal(false)} />



            </Box>

        </MainLayout>
    )
}
